import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { UiContext } from 'uiContext';
import { FerecastProps } from 'components/forecast/forecastTypes';
import map from 'lodash/map';
import ForecastItemDesktop from 'components/forecast/forecastItem/forecastItemDesktop';

export default function ForecastDesktop({ items }: FerecastProps) {
  const {
    spacings: {
      uiElems: {
        speedStat: { desktop },
      },
      sp,
    },
  } = useContext(UiContext);

  return (
    <Box
      sx={{
        display: 'flex',
        alignSelf: 'stretch',
        gap: sp.s25,
        height: desktop.height,
      }}
    >
      {map(items, (item, i) => (
        <ForecastItemDesktop key={i} {...item}></ForecastItemDesktop>
      ))}
    </Box>
  );
}
